/* eslint-disable max-len */
// modules
import React from 'react';

// aliased
import Link from 'components/Link';

// local
import styles from './data.pcss';

// <Link key={ 0 } className={ styles.link } to={ '/portfolio/nike-valiant-labs' }>
// { 'Valiant Labs' }
// </Link>

export default [
  {
    company: 'nike',
    slug: 'nike-engineering-manager',
    title: 'Engineering Manager',
    dates: ['Mar 2020'],
    location: 'Portland, OR',
    description: [
      (
        <span key={ 0 }>
          { 'Innovation @ ' }
          <Link className={ styles.link } to={ '/portfolio/nike-valiant-labs' }>{ 'Nike Valiant Labs' }</Link>
        </span>
      ),
    ],
  },
  {
    company: 'nike',
    slug: 'nike-lead-software-engineer',
    title: 'Lead Software Engineer',
    dates: ['Sep 2018', 'Mar 2020'],
    location: 'Portland, OR',
    description: [
      (
        <span key={ 0 }>
          { 'Innovation @ ' }
          <Link className={ styles.link } to={ '/portfolio/nike-valiant-labs' }>{ 'Nike Valiant Labs' }</Link>
        </span>
      ),
    ],
  },
  {
    company: 'nike',
    slug: 'nike-senior-software-engineer',
    title: 'Senior Software Engineer',
    dates: ['Jan 2018', 'Sep 2018'],
    location: 'Portland, OR',
    showIcon: false,
    description: [
      // 'Innovation @ Nike Valiant Labs',
    ],
  },
  {
    company: 'reserve',
    slug: 'reserve-software-engineer',
    title: 'Software Engineer',
    dates: ['Jun 2015', 'Jun 2017'],
    location: 'New York City / Remote',
    description: [
      (
        <span key={ 0 }>
          <span>{ 'Led the web team to deliver ' }</span>
          <Link className={ styles.link } to={ '/portfolio/reserve-dot-com' }>{ 'reserve.com' }</Link>
          <span>{ ' and ' }</span>
          <Link className={ styles.link } to={ '/portfolio/reserve-rfr-web' }>{ 'RFR table management' }</Link>
          <span>{ ' products' }</span>
        </span>
      ),
      'Designed REST APIs with complex reservation logic to support consumer, back-of-house, and internal applications',
      'Created performant front-end UX, including a drag & drop floor plan editor, and realtime chat',
    ],
  },
  {
    company: 'camerama',
    slug: 'camerama',
    title: 'Co-founder, Lead Backend Engineer, DevOps',
    dates: ['Jun 2014', 'Mar 2015'],
    location: 'New York City',
    description: [
      'Led development of cloud infrastructure and APIs',
      (
        <span key={ 1 }>
          <Link className={ styles.link } to={ 'https://www.forbes.com/sites/forbespr/2015/03/16/forbes-media-acquires-private-photo-sharing-app-camerama' }>{ 'Acquired by Forbes ' }</Link>
          <span>{ ' in March 2015' }</span>
        </span>
      ),
    ],
  },
  {
    company: 'tigerspike',
    slug: 'tigerspike-is-manager',
    title: 'Information Systems Manager / Software Engineer',
    dates: ['Dec 2012', 'May 2015'],
    location: 'New York City',
    description: [
      (
        <span key={ 0 }>
          <span>{ 'Client-facing tech-lead and full-stack engineer for key relationships, including: ' }</span>
          <Link className={ styles.link } to={ '/portfolio/amex-global-mpj' }>{ 'Amex' }</Link>
          <span>{ ', ' }</span>
          <Link className={ styles.link } to={ '/portfolio/directv-pattern-cloud' }>{ 'DirectTV' }</Link>
          <span>{ ', and ' }</span>
          <Link className={ styles.link } to={ '/portfolio/lazard-dot-com' }>{ 'Lazard' }</Link>
        </span>
      ),
      'Designed and installed NY office network infrastructure, VOIP, and keyless access systems',
      'Managed staff technology policies, procurement, provisioning, and asset management',
      'Recipient of the "Trust and Innovation Award" in 2013',
      // 'Maintained AWS infrastructure for internal applications',
    ],
  },
  // {
  //   company: 'freelance',
  //   slug: 'freelance',
  //   title: 'Software Engineer',
  //   dates: ['2013'],
  //   location: '',
  //   description: [
  //     'Various advisory and engineering roles, for companies like Bumblegram, and Ansell',
  //   ],
  // },
  // {
  //   company: 'tigerspike',
  //   slug: 'tigerspike-global-knowledge-analyst',
  //   title: 'Global Knowledge Analyst',
  //   dates: ['Nov 2011', 'Dec 2012'],
  //   location: 'New York City',
  //   description: [
  //     'Worked with offices in six countries to share knowledge, process, and best practice',
  //     'Setup and managed NetSuite (CRM + ERP) for North America. Automated operations, and integrated the intranet with internal and third-party tools',
  //     // 'Rebuilt the intranet... why? ADD A STAT',
  //     'Built a widely used internal link shortening service to improve marketing analytics',
  //   ],
  // },
  // {
  //   company: 'tigerspike',
  //   slug: 'tigerspike-account-exec',
  //   title: 'Account Executive',
  //   dates: ['Dec 2010', 'Nov 2011'],
  //   location: 'New York City',
  //   description: [
  //     'Implemented a new CRM system and managed leads for the NYC sales team',
  //     'Wrote RFP responses, and pitched the company to potential clients',
  //   ],
  // },
  // {
  //   company: 'tigerspike',
  //   slug: 'tigerspike-bd-analyst',
  //   title: 'Business Development Analyst',
  //   dates: ['Aug 2010', 'Dec 2010'],
  //   location: 'New York City',
  //   description: [],
  // },
  // {
  //   company: 'saks',
  //   slug: 'saks-watch-specialist',
  //   title: 'Watch Specialist',
  //   dates: ['Sep 2005', 'Jun 2008'],
  //   location: 'New York City',
  //   description: [],
  // },
];



// WEBPACK FOOTER //
// ./src/data/jobs.jsx